import { Modal } from '../../components/Modal/Modal'
import { Modal as BootstrapModal } from 'react-bootstrap'
import React from 'react'
import { MeetingTemplate } from '../../store/ai/meetingTemplate'

interface MeetingTemplateVisibilityChangeConfirmationModalProps {
  meetingTemplate: MeetingTemplate
  show: boolean
  onConfirm: () => void
  onHide: () => void
}

export const MeetingTemplateVisibilityChangeConfirmationModal: React.FC<MeetingTemplateVisibilityChangeConfirmationModalProps> = ({
  meetingTemplate,
  show,
  onConfirm,
  onHide,
}) => {
  const visibilityDescriptionMessage = meetingTemplate.isPrivate ? 'private and visible only to participants' : 'public and visible to everyone'

  return (
    <Modal
      header={<BootstrapModal.Title>Change meeting visibility</BootstrapModal.Title>}
      body={
        <div>
          <p className='zocks-text-gray-900'>{`Changing to the ${meetingTemplate.name} Meeting Type will make this meeting ${visibilityDescriptionMessage}.`}</p>
        </div>
      }
      show={show}
      onHide={onHide}
      footerPrimaryActionTitle='Change anyway'
      showFooterActions={true}
      centered
      onFooterPrimaryAction={onConfirm}
      onFooterSecondaryAction={onHide}
      headerBodySeparator={true}
    />
  )
}
